import styled from 'styled-components';
import { OLAF } from 'HubStyleTokens/colors';
import UIStatusDot from 'UIComponents/tag/UIStatusDot';
import { useVisitorIsPresent } from 'conversations-thread-data/presence/public/hooks';
import { useThreadDetails } from 'conversations-thread-view/thread-details-feature/public/hooks/useThreadDetails';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { getVid } from 'conversations-thread-data/thread-details/public/operators';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledStatusDot = styled(UIStatusDot).withConfig({
  displayName: "StatusIndicator__StyledStatusDot",
  componentId: "h54mut-0"
})(["position:absolute;right:-10px;bottom:7px;width:12px !important;height:12px !important;border-radius:50%;border:1px solid ", ";"], OLAF);
const StatusIndicator = ({
  threadId
}) => {
  const {
    asyncThreadDetails
  } = useThreadDetails({
    threadId
  });
  const threadDetailsData = getData(asyncThreadDetails);
  /*  @ts-expect-error Jun-7-2024, 15:40UTC TODO: fix broken types introduced from typing of ThreadDetails record: https://git.hubteam.com/HubSpot/conversations-thread-view/pull/3656  */
  const vid = threadDetailsData ? getVid(threadDetailsData) : null;

  /*  @ts-expect-error Jun-7-2024, 15:40UTC TODO: fix broken types introduced from typing of ThreadDetails record: https://git.hubteam.com/HubSpot/conversations-thread-view/pull/3656  */
  const {
    visitorIsPresent
  } = useVisitorIsPresent({
    threadId,
    vid
  });
  return visitorIsPresent ? /*#__PURE__*/_jsx(StyledStatusDot, {
    use: "success"
  }) : null;
};
StatusIndicator.displayName = 'StatusIndicator';
export default StatusIndicator;